import { Injectable } from '@angular/core';

import { AuthHelpers, CompanySwitchStrategy } from '@recruitee/http';
import { WindowRef } from '@recruitee/user-interface';

@Injectable()
export class RecruiteeCompanySwitchStrategy implements CompanySwitchStrategy {
  constructor(
    private authHelpers: AuthHelpers,
    private windowRef: WindowRef,
  ) {}

  public switchCompany(companyId: string) {
    const nativeWindow = this.windowRef.nativeWindow;

    this.authHelpers.clearCompanyCookies();
    this.authHelpers.saveCompanyInCookie(companyId);
    nativeWindow.location.href = nativeWindow.document.baseURI + '#/dashboard/overview';
    nativeWindow.location.reload();
  }
}
